import { atom } from 'recoil';
import defaultTemplate from 'ProjectManager/Template/Common/recoil/defaultTemplate';

const templateAtom = atom({
    key: 'projectManagement_templateDataManagement',
    default: defaultTemplate,
});

export default templateAtom;
